module.exports = __webpack_public_path__ + "static/media/check.8e6528b3.svg";